import axios, { AxiosPromise, AxiosRequestConfig } from "axios";

import { execute } from "./core";

type Payload = {} | FormData;

export const get = <T>(url: string, options?: AxiosRequestConfig): AxiosPromise<T> => {
  return execute<T>(url, options);
};

export const post = <T>(url: string, data?: Payload, options?: AxiosRequestConfig): AxiosPromise<T> => {
  const request = Object.assign({}, options, { data, method: "POST" });
  return execute<T>(url, request);
};

export const put = <T>(url: string, data?: Payload, options?: AxiosRequestConfig): AxiosPromise<T> => {
  const request = Object.assign({}, options, { data, method: "PUT" });
  return execute<T>(url, request);
};

export const remove = <T>(url: string, data?: Payload, options?: AxiosRequestConfig): AxiosPromise<T> => {
  const request = Object.assign({}, options, { data, method: "DELETE" });
  return execute<T>(url, request);
};

export const http = axios;
